export enum NonConformanceReportConcernOrigin {
	Internal = 0,
	ExternalClient = 10,
	ExternalSupplier = 20,
}